import TextElement from './TextElement.vue';
import TextButtonElement from './TextButtonElement.vue';
import ImageElement from './ImageElement.vue';
import DocumentElement from './DocumentElement.vue';
import ListElement from './ListElement.vue';
import AudioElement from './AudioElement.vue';
import DelayElement from './DelayElement.vue';
import RequestElement from './RequestElement.vue';
import AnswerElement from './AnswerElement.vue';
import RedirectElement from './RedirectElement.vue';
import NotificationElement from './NotificationElement.vue';
import VariableInsertElement from './VariableInsertElement.vue';
import LocationRequestElement from './LocationRequestElement.vue';
import ButtonLinkElement from './ButtonLinkElement.vue';

export {
  TextElement,
  TextButtonElement,
  ImageElement,
  DocumentElement,
  ListElement,
  AudioElement,
  DelayElement,
  RequestElement,
  AnswerElement,
  RedirectElement,
  NotificationElement,
  VariableInsertElement,
  LocationRequestElement,
  ButtonLinkElement
};

// Mapping des types d'éléments aux composants
export const ELEMENT_COMPONENTS = {
  text: TextElement,
  text_button: TextButtonElement,
  text_buttons: TextButtonElement, // Ajout d'une variante avec 's' pour compatibilité
  interactive_buttons: TextButtonElement, // Autre variante possible
  buttons: TextButtonElement, // Autre variante possible
  image: ImageElement,
  document: DocumentElement,
  list: ListElement,
  audio: AudioElement,
  delay: DelayElement,
  request: RequestElement,
  answer: AnswerElement,
  redirection: RedirectElement,
  notification: NotificationElement,
  variable_insert: VariableInsertElement,
  location_request_message: LocationRequestElement,
  button_link: ButtonLinkElement
};

export default ELEMENT_COMPONENTS;
